module.exports = __webpack_public_path__ + "img/89ne.71b868a3.svg";